import axios, { CancelTokenSource, CancelTokenStatic } from 'axios'
const CancelToken = axios.CancelToken

// NOTE: axiosSettingsを使った読み込みをキャンセルするため、axios本体をインポートしなくてもキャンセルトークンを得られるユーティリティを作りました。
// CancelTokenSourceを無名関数に閉じ込めて、スコープ内部で共有されるようにしています。
//
// 使い方：
// const myLoader = axiosCancelTokenProvider<返却される関数の型>((cancelSource, CancelToken) => {
//   if (cancelSource) {
//     cancelSource.cancel()
//   }
//   cancelSource = CancelToken.source()
//   // axiosもしくはaxiosSettingsを使った非同期関数を返す
//   return () =>
//     axios.get(`/api/${page}`, {
//       cancelToken: cancelSource?.token // キャンセルトークンを渡す
//     })
// })
// myLoader() // キャンセル
// myLoader() // キャンセル
// myLoader() // 有効

export const axiosCancelTokenProvider = <T extends Function>(
  fn: (source: CancelTokenSource | null, CancelToken: CancelTokenStatic) => T
) => {
  return ((source: CancelTokenSource | null) => fn(source, CancelToken))(null)
}
